@use '@lib/assets/styles/main.scss' as *;

$accordion-duration: 200ms;
$accordion-easing: ease;

.toggle {
  background-color: $blue20;
  border-radius: 6px;
  padding: 8px 56px 8px 16px;
  display: flex;
  align-items: center;
  gap: 4px;
  height: 56px;
  position: relative;
  cursor: pointer;
  border: none;
  text-align: left;
  width: 100%;
}

.title {
  flex: 1;
  min-width: 0;
}

.icon {
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  transition: transform $accordion-duration $accordion-easing;

  .toggleOpen & {
    transform: translateY(-50%) rotate(180deg);
  }
}

.panel {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows $accordion-duration $accordion-easing;
}

.panelOpen {
  grid-template-rows: 1fr;
}

.panelInner {
  overflow: hidden;
}

.content {
  padding-top: 24px;
}
